import i18n from './../../shared/i18n';
import BaseModel from "../../core/components/input-widget/BaseModel";
import DateModel from "../sales/Date.model";
import {store} from "@/plugins/vuex";

export default class ReservationModel extends BaseModel {
  uuid = null;
  auction_uuid = null;
  lot_no = null;
  sale_no = null;
  quantity = 1;
  low = null;
  high = null;
  start_price = null;
  reserve = null;
  collected = false;
  status = store.state.global.enableContinuousAuction ? 'lotted' : 'reserved';
  dates = [new DateModel()];

  rules = {
    quantity: 'required',
  };

  customMessages = {
    "quantity": {
      max_value: function (name, rule) {
        return i18n.t('This value cannot exceed the available quantity of {val}', {val: rule.max})
      },
    }
  }

  attributeHints = {};

  attributeLabels = {
    lot_no: i18n.t('Lot'),
    sale_no: i18n.t('Sale'),
    quantity: i18n.t('Quantity'),
    low: i18n.t('Low'),
    high: i18n.t('High'),
    start_price: i18n.t('Start Price'),
    reserve: i18n.t('Reserve'),
    collected: i18n.t('Collected'),
    status: i18n.t('Status'),
    auction_uuid: i18n.t('Sale'),
  };

  constructor(data = {}) {
    super();

    let tmpData = data;

    if (tmpData.auction && tmpData.auction.dates && store.state.global.enableContinuousAuction) {
      tmpData.dates = [new DateModel(tmpData.auction.dates[0])]
    }

    Object.assign(this, {...tmpData});
  }

  isUnsoldOrWithdrawn() {
    return ['unsold', 'withdrawn'].includes(this.status)
  }

  isUnsoldOrWithdrawnOrSold() {
    return ['unsold', 'withdrawn', 'sold'].includes(this.status)
  }
}
